<template>
    <div class="payment-items-list">
        <PaymentItem
            v-for="item in props.paymentItems"
            :key="item.id"
            :item="item"
            :quantityDigits="orderItemsQuantityDigits"
            :showInternalNames="props.showInternalNames"
            :alwaysShowGroupName="props.alwaysShowGroupName"
        />
    </div>
</template>

<script setup lang="ts">
    import type { ICustomerPaymentItem } from "@/data/model/CustomerPayment";
    import { computed } from "vue";

    import PaymentItem from "@/components/order/PaymentItem.vue";

    // define properties
    const props = defineProps<{
        paymentItems: ICustomerPaymentItem[];
        showInternalNames: boolean;
        alwaysShowGroupName?: boolean;
    }>();

    // define computed
    const orderItemsQuantityDigits = computed(() => {
        let maxLength = 1;
        for (const item of props.paymentItems) {
            const itemDigits = item.quantity.toString().length;
            maxLength = Math.max(maxLength, itemDigits);
        }
        return maxLength;
    });
</script>

<style scoped lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";

    .payment-items-list {
        font-size: 16px;
        color: colors.$fontColor;
    }
</style>
